import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { Chip } from "@mui/material";
import {
  OrganizationMessageSeverity,
  type OrganizationMessageFieldsFragment,
} from "../../../generated/graphql";
import {
  displayStatus,
  SEVERITY_DISPLAY,
  STATUS_DISPLAY,
} from "../message-content";

export const SEVERITY_ICON = {
  [OrganizationMessageSeverity.Info]: InfoOutlinedIcon,
  [OrganizationMessageSeverity.Warning]: WarningAmberIcon,
  [OrganizationMessageSeverity.Critical]: ErrorOutlineIcon,
} as const;

export const SeverityChip = ({
  severity,
}: {
  readonly severity: OrganizationMessageSeverity;
}) => {
  const Icon = SEVERITY_ICON[severity];
  return (
    <Chip
      size="small"
      variant="outlined"
      color={SEVERITY_DISPLAY[severity].color}
      icon={<Icon />}
      label={SEVERITY_DISPLAY[severity].label}
    />
  );
};

export const StatusChip = ({
  message,
}: {
  readonly message: Pick<
    OrganizationMessageFieldsFragment,
    "status" | "expiresAt"
  >;
}) => {
  const display = STATUS_DISPLAY[displayStatus(message)] ?? {
    label: message.status,
    color: "default" as const,
  };
  return <Chip size="small" color={display.color} label={display.label} />;
};
